// Mock data for dairy products e-commerce

export const products = [
  // Pure Ghee Products
  {
    id: "1",
    name: "Arihant Pure Ghee 100 ml",
    category: "pure_ghee",
    price: 75,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/z1wccs62_WhatsApp%20Image%202025-10-27%20at%2021.47.29%20%281%29.jpeg",
    description: "Premium quality pure ghee made from finest milk",
    weight: "100ml",
    inStock: true
  },
  {
    id: "2",
    name: "Arihant Pure Ghee 200 ml",
    category: "pure_ghee",
    price: 140,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/vi73x46p_WhatsApp%20Image%202025-10-27%20at%2021.47.29.jpeg",
    description: "Premium quality pure ghee made from finest milk",
    weight: "200ml",
    inStock: true
  },
  {
    id: "3",
    name: "Arihant Pure Ghee 500 ml",
    category: "pure_ghee",
    price: 345,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/tlasxctr_WhatsApp%20Image%202025-10-27%20at%2021.47.28%20%281%29.jpeg",
    description: "Premium quality pure ghee made from finest milk",
    weight: "500ml",
    inStock: true
  },
  {
    id: "4",
    name: "Arihant Pure Ghee 1 Liter",
    category: "pure_ghee",
    price: 680,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/b8qui737_WhatsApp%20Image%202025-10-27%20at%2021.47.28.jpeg",
    description: "Premium quality pure ghee made from finest milk",
    weight: "1L",
    inStock: true
  },
  {
    id: "4a",
    name: "Arihant Pure Ghee Jar 1 Liter",
    category: "pure_ghee",
    price: 685,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/dvdim3k9_WhatsApp%20Image%202025-10-27%20at%2021.47.29%20%282%29.jpeg",
    description: "Premium quality pure ghee in jar packaging - 1 Liter",
    weight: "1L Jar",
    inStock: true
  },
  {
    id: "4b",
    name: "Arihant Pure Ghee Jar 500 ml",
    category: "pure_ghee",
    price: 350,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/fuwb6lu9_WhatsApp%20Image%202025-10-27%20at%2021.47.30.jpeg",
    description: "Premium quality pure ghee in jar packaging - 500ml",
    weight: "500ml Jar",
    inStock: true
  },
  {
    id: "4c",
    name: "Arihant Pure Ghee Jar 200 ml",
    category: "pure_ghee",
    price: 145,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/ml65hkvk_WhatsApp%20Image%202025-10-27%20at%2021.47.30%20%281%29.jpeg",
    description: "Premium quality pure ghee in jar packaging - 200ml",
    weight: "200ml Jar",
    inStock: true
  },
  {
    id: "4d",
    name: "Arihant Pure Ghee Jar 100 ml",
    category: "pure_ghee",
    price: 80,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/b925wygn_WhatsApp%20Image%202025-10-27%20at%2021.47.30%20%282%29.jpeg",
    description: "Premium quality pure ghee in jar packaging - 100ml",
    weight: "100ml Jar",
    inStock: true
  },
  {
    id: "4e",
    name: "Arihant Pure Ghee Jar 5 Liter",
    category: "pure_ghee",
    price: 3450,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/4zkl45d4_WhatsApp%20Image%202025-10-27%20at%2021.47.34%20%281%29.jpeg",
    description: "Premium quality pure ghee in jar packaging - 5 Liter",
    weight: "5L Jar",
    inStock: true
  },
  {
    id: "4f",
    name: "Arihant Pure Ghee Jar 15 Liter",
    category: "pure_ghee",
    price: 10300,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/zay3zm33_WhatsApp%20Image%202025-10-27%20at%2021.47.34%20%282%29.jpeg",
    description: "Premium quality pure ghee in jar packaging - 15 Liter",
    weight: "15L Jar",
    inStock: true
  },
  {
    id: "5",
    name: "Arihant Pure Ghee 5 Kgs",
    category: "pure_ghee",
    price: 3650,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/wo51wgmh_WhatsApp%20Image%202025-10-27%20at%2021.47.35%20%281%29.jpeg",
    description: "Premium quality pure ghee made from finest milk - Bulk pack",
    weight: "5kg",
    inStock: true
  },
  {
    id: "6",
    name: "Arihant Pure Ghee 15 Kgs",
    category: "pure_ghee",
    price: 10800,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/nh87t5s9_WhatsApp%20Image%202025-10-27%20at%2021.47.35.jpeg",
    description: "Premium quality pure ghee made from finest milk - Bulk pack",
    weight: "15kg",
    inStock: true
  },
  {
    id: "6a",
    name: "Arihant Pure Ghee Pouch 20g",
    category: "pure_ghee",
    price: 20,
    image: "",
    description: "Premium quality pure ghee in convenient pouch",
    weight: "20g",
    inStock: true
  },
  // Cow Ghee Products
  {
    id: "7",
    name: "Arihant Cow Ghee 100 ml",
    category: "cow_ghee",
    price: 85,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/9j2wbqgj_WhatsApp%20Image%202025-10-27%20at%2021.47.34.jpeg",
    description: "Pure cow ghee made from 100% cow milk",
    weight: "100ml",
    inStock: true
  },
  {
    id: "8",
    name: "Arihant Cow Ghee 200 ml",
    category: "cow_ghee",
    price: 150,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/343urpid_WhatsApp%20Image%202025-10-27%20at%2021.47.33%20%282%29.jpeg",
    description: "Pure cow ghee made from 100% cow milk",
    weight: "200ml",
    inStock: true
  },
  {
    id: "9",
    name: "Arihant Cow Ghee 500 ml",
    category: "cow_ghee",
    price: 355,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/r1o30dqh_WhatsApp%20Image%202025-10-27%20at%2021.47.33%20%281%29.jpeg",
    description: "Pure cow ghee made from 100% cow milk",
    weight: "500ml",
    inStock: true
  },
  {
    id: "10",
    name: "Arihant Cow Ghee 1 Liter",
    category: "cow_ghee",
    price: 700,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/alw775fn_WhatsApp%20Image%202025-10-27%20at%2021.47.33.jpeg",
    description: "Pure cow ghee made from 100% cow milk",
    weight: "1L",
    inStock: true
  },
  {
    id: "10a",
    name: "Arihant Cow Ghee 5 Liter Jar",
    category: "cow_ghee",
    price: 3550,
    image: "",
    description: "Pure cow ghee made from 100% cow milk in jar",
    weight: "5L Jar",
    inStock: true
  },
  {
    id: "11",
    name: "Arihant Cow Ghee 5 Kgs",
    category: "cow_ghee",
    price: 3750,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/8vytyqeq_WhatsApp%20Image%202025-10-27%20at%2021.47.37%20%281%29.jpeg",
    description: "Pure cow ghee made from 100% cow milk - Bulk pack",
    weight: "5kg",
    inStock: true
  },
  {
    id: "12",
    name: "Arihant Cow Ghee 15 Kgs",
    category: "cow_ghee",
    price: 11000,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/yr5d0acv_WhatsApp%20Image%202025-10-27%20at%2021.47.47%20%281%29.jpeg",
    description: "Pure cow ghee made from 100% cow milk - Bulk pack",
    weight: "15kg",
    inStock: true
  },
  // Sweets
  {
    id: "18",
    name: "Arihant Gulab Jamun",
    category: "sweets",
    price: 285,
    image: "https://customer-assets.emergentagent.com/job_selected-repo/artifacts/6zii0b0t_42BE2135-F44E-4722-AEF0-2566BD977366.png",
    description: "Delicious traditional Indian sweet made with milk solids, soaked in sugar syrup",
    weight: "1kg",
    inStock: true
  },
  {
    id: "19",
    name: "Arihant Rasgulla",
    category: "sweets",
    price: 275,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/dkkktvn3_WhatsApp%20Image%202025-10-27%20at%2021.47.37%20%282%29.jpeg",
    description: "Soft and spongy cottage cheese balls soaked in light sugar syrup",
    weight: "1kg",
    inStock: true
  },
  // Dairy Whitener
  {
    id: "20",
    name: "Arihant Dairy Whitener 12g",
    category: "dairy_whitener",
    price: 5,
    image: "",
    description: "Premium dairy whitener for tea and coffee",
    weight: "12g",
    inStock: true
  },
  {
    id: "21",
    name: "Arihant Dairy Whitener 24g",
    category: "dairy_whitener",
    price: 10,
    image: "",
    description: "Premium dairy whitener for tea and coffee",
    weight: "24g",
    inStock: true
  },
  {
    id: "22",
    name: "Arihant Dairy Whitener 100g",
    category: "dairy_whitener",
    price: 55,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/xbn5mh5f_WhatsApp%20Image%202025-10-27%20at%2021.47.38.jpeg",
    description: "Premium dairy whitener for tea and coffee",
    weight: "100g",
    inStock: true
  },
  {
    id: "23",
    name: "Arihant Dairy Whitener 200g",
    category: "dairy_whitener",
    price: 90,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/79s119hd_WhatsApp%20Image%202025-10-27%20at%2021.47.39.jpeg",
    description: "Premium dairy whitener for tea and coffee",
    weight: "200g",
    inStock: true
  },
  {
    id: "24",
    name: "Arihant Dairy Whitener 500g",
    category: "dairy_whitener",
    price: 220,
    image: "https://customer-assets.emergentagent.com/job_timekeeper-api/artifacts/vnmmr96h_WhatsApp%20Image%202025-10-27%20at%2021.47.39%20%281%29.jpeg",
    description: "Premium dairy whitener for tea and coffee",
    weight: "500g",
    inStock: true
  },
  // Skimmed Milk Powder
  {
    id: "25",
    name: "Nevedya Skim Milk Powder 500g",
    category: "naivedya_milk_powder",
    price: 295,
    image: "",
    description: "Premium skimmed milk powder",
    weight: "500g",
    inStock: true
  },
  {
    id: "26",
    name: "Nevedya Skim Milk Powder 1kg",
    category: "naivedya_milk_powder",
    price: 550,
    image: "",
    description: "Premium skimmed milk powder",
    weight: "1kg",
    inStock: true
  },
  {
    id: "27",
    name: "Nevedya Skim Milk Powder 25kg Loose",
    category: "naivedya_milk_powder",
    price: 7925,
    image: "",
    description: "Premium skimmed milk powder - Bulk pack",
    weight: "25kg",
    inStock: true
  }
];

export const categories = [
  { id: 'all', name: 'All Products' },
  { id: 'pure_ghee', name: 'Pure Ghee' },
  { id: 'cow_ghee', name: 'Cow Ghee' },
  { id: 'sweets', name: 'Sweets' },
  { id: 'dairy_whitener', name: 'Dairy Whitener' },
  { id: 'skim_milk_powder', name: 'Skimmed Milk Powder' },
  { id: 'naivedya_milk_powder', name: 'Nevedya Skimmed Milk Powder' },
  { id: 'whole_milk_powder', name: 'Whole Milk Powder' }
];

export const teamMembers = [
  {
    id: 1,
    name: "Abhay Surana",
    role: "Director",
    bio: "Leading Arihant Milk Products with vision and dedication to quality dairy excellence",
    image: "https://customer-assets.emergentagent.com/job_f5e3540e-97a9-470e-8a92-ab500e1eb8c7/artifacts/d5au3hk1_IMG_9650.jpg",
    linkedin: ""
  },
  {
    id: 2,
    name: "Akshay Surana",
    role: "Director",
    bio: "Driving innovation and operational excellence in dairy production",
    image: "https://customer-assets.emergentagent.com/job_f5e3540e-97a9-470e-8a92-ab500e1eb8c7/artifacts/pg5as5hc_IMG_9649.jpg",
    linkedin: ""
  },
  {
    id: 3,
    name: "Ujjawal Surana",
    role: "Director",
    bio: "Ensuring quality standards and customer satisfaction across all operations",
    image: "https://customer-assets.emergentagent.com/job_f5e3540e-97a9-470e-8a92-ab500e1eb8c7/artifacts/g7dnu09u_Screenshot%202025-10-27%20at%202.53.31%E2%80%AFAM.png",
    linkedin: ""
  },
  {
    id: 4,
    name: "Saksham Surana",
    role: "Director",
    bio: "Managing strategic growth and business development initiatives",
    image: "https://customer-assets.emergentagent.com/job_f5e3540e-97a9-470e-8a92-ab500e1eb8c7/artifacts/km39p4wu_IMG_9651.jpg",
    linkedin: ""
  },
  {
    id: 5,
    name: "Rajat Surana",
    role: "Director",
    bio: "Overseeing production quality and maintaining traditional dairy practices",
    image: "https://customer-assets.emergentagent.com/job_f5e3540e-97a9-470e-8a92-ab500e1eb8c7/artifacts/1ck6yrpa_Screenshot%202025-10-27%20at%202.52.58%E2%80%AFAM.png",
    linkedin: ""
  },
  {
    id: 6,
    name: "Samarth Surana",
    role: "Director",
    bio: "Samarth Surana leads Arihant's international business development, driving global partnerships and expanding the company's presence in dairy export markets across the world.",
    // FIX: Use the full path. Place samarth.jpg in your public folder, OR upload it to
    // emergentagent like the other photos and paste the URL here.
    image: "/samarth.JPG",
    linkedin: "https://www.linkedin.com/in/samarth-surana-272a13210/"
  }
];
